/**
 * Copyright (c) 2018-present clchart Contributors.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// 以下是 ClLineAxisX 的实体定义

import {
    // _drawLineAlone,
    _drawTxt,
    _fillRect
} from './cl.draw'
import {
    initCommonInfo
} from './cl.chart.init'

// 创建时必须带入父类，后面的运算定位都会基于父节点进行；
// 这个类仅仅是画图, 因此需要把可以控制的rect传入进来
/**
 * Class representing ClDrawAxisX
 * @export
 * @class ClDrawAxisX
 */
export default class ClDrawAxisX {
    /**

     * Creates an instance of ClDrawAxisX.
     * @param {Object} father
     * @param {Object} rectMain
     */
    constructor(father, rectMain) {
        initCommonInfo(this, father)
        this.rectMain = rectMain

        this.dataLayer = father.father.dataLayer
        this.linkInfo = this.dataLayer.linkInfo

        this.axisXinfo = this.dataLayer.axisXinfo

        this.axisX = father.config.axisX
        // this.text = father.layout.title
        this.text = father.layout.axisX
    }
    /**
     * pain axisx
     * @memberof ClDrawAxisX
     */
    getValue(method, index) {
        let val = ''
        // console.log(this.axisXinfo.dataTxt);
        switch (method) {
            case 'XdataTxt-left':
                val = this.axisXinfo.dataTxt[this.linkInfo.minIndex]
                break;
            case 'XdataTxt-right':
                val = this.axisXinfo.dataTxt[this.linkInfo.maxIndex]
                break;
            case 'XuserTxt-left':
                //
                val = father.axisXdata.min
                break;
            case 'XuserTxt-right':
                val = father.axisXdata.max
                break;
            case 'XdataTxt':
                val = this.axisXinfo.dataTxt[index]
                break;
            case 'XshowTxt':
                val = this.axisXinfo.showTxt[index]
                break;
            default:
                break;
        }
        return val
    }
    onPaint() {
        if (this.axisX.display === 'none') {
            return
        }
        const yy = this.rectMain.top + this.rectMain.height / 2 - this.scale
        if (this.axisX.display === 'whole') {
            const spaceX = this.rectMain.width / (this.linkInfo.maxIndex - this.linkInfo.minIndex + 1)
            for (let index = this.linkInfo.minIndex; index <= this.linkInfo.maxIndex; index++) {
                const xx = this.rectMain.left + spaceX / 2 + spaceX * index
                const value = this.getValue(this.axisX.left.getvar, index)
                if (value !== undefined) {
                    _drawTxt(this.context, xx, yy, value,
                        this.text.font, this.text.pixel, this.color.axis, {
                            x: 'center',
                            y: 'middle'
                        })
                }
                
            }
        } else {
            if (this.axisX.left && this.axisX.left.display !== 'none') {
                const xx = this.rectMain.left + this.text.spaceX
                const value = this.getValue(this.axisX.left.getvar + '-left')
                if (value !== undefined) {
                    _drawTxt(this.context, xx, yy, value,
                        this.text.font, this.text.pixel, this.color.axis, {
                            y: 'middle'
                        })
                }
            }
            if (this.axisX.right && this.axisX.right.display !== 'none') {
                const xx = this.rectMain.left + this.rectMain.width - 3
                const value = this.getValue(this.axisX.left.getvar + '-right')
                if (value !== undefined) {
                    _drawTxt(this.context, xx, yy, value,
                        this.text.font, this.text.pixel, this.color.axis, {
                            y: 'middle',
                            x: 'end'
                        })
                }
            }
            if (this.axisX.middle && this.axisX.middle.display !== 'none') {
                const chunks = this.axisXinfo.showTxt.length
                if (chunks > 0) {
                    const spaceX = this.rectMain.width / chunks
                    for (let index = 0; index < chunks; index++) {
                        const xx = this.rectMain.left + spaceX / 2 + spaceX * index
                        _drawTxt(this.context, xx, yy, this.axisXinfo.showTxt[index],
                            this.text.font, this.text.pixel, this.color.axis, {
                                y: 'middle',
                                x: 'center'
                            })
                    }
                }
            }
        }
    }
}